import React, { useEffect, useState } from 'react';
import {
  Avatar,
  IconButton,
  Typography,
  Badge,
  useMediaQuery,
} from '@mui/material';
import DefaultAdvisorAvatar from '../../icons/user-avatar.svg';
import ConversationNotification from './Notification';
import CustomIcon from '../../icons/customIcon';

const useStyles = (isSM) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    height: '67px',
    cursor: 'pointer',
    borderRight: 'none',
    backgroundColor: '#FBFCFD',
  },
  cardContainer: {
    marginLeft: '15px',
  },
  displayName: {
    whiteSpace: 'pre',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    color: '#232B35',
  },
  position: {
    whiteSpace: 'pre',
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: '10px',
    letterSpacing: '0.75px',
    color: '#1C2F49',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'end',
    fontWeight: 400,
    marginRight: '20px',
  },
  rowContainer: {
    width: '100%',
    boxSizing: 'content-box',
    borderLeft: '#FBFCFD solid 4px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '100%',
  },
  selectedRow: {
    borderLeft: '#0F78FD solid 3px',
    backgroundColor: '#F9FBFF',
  },
  infoContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    overflow: 'hidden',
    width: '100%',
    marginLeft: '15px',
  },
});

function ConversationLeftMenuItem(props) {
  const { setConversationId, currentConversationId, unread, ceo } = props;
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles(isSM);
  const isSelected = function () {
    return currentConversationId === 'ceoMessage';
  };

  function formatText(text, size) {
    if (text && text.length > size) {
      text.substring(0, size);
      return `${text.substring(0, size)}...`;
    }
    return text;
  }

  function goToConversation() {
    setConversationId('ceoMessage');
  }

  return (
    <div style={classes.container} onClick={goToConversation} role="none">
      <div
        style={{
          ...classes.rowContainer,
          ...(isSelected() ? classes.selectedRow : {}),
        }}
      >
        <div style={classes.infoContainer}>
          <div>
            <Badge
              color="error"
              variant="dot"
              invisible={unread === 0}
              sx={{
                '& .MuiBadge-badge': {
                  top: '85%',
                  right: '15%',
                  transform: 'translate(50%, -50%)',
                },
              }}
            >
              <Avatar
                src={ceo.image || DefaultAdvisorAvatar}
                style={{ width: '48px', height: '48px' }}
              />
            </Badge>
          </div>
          <div style={classes.cardContainer}>
            <Typography sx={classes.displayName}>
              {formatText(ceo.name, 15)}
            </Typography>
            <Typography sx={classes.position}>
              {formatText(ceo.position, 20)}
            </Typography>
          </div>
        </div>
        <div style={classes.iconContainer}>
          <IconButton style={{ backgroundColor: '#F5F7FA', padding: '7px' }}>
            <CustomIcon iconname="comments" style={{ fontSize: '21px' }} />
          </IconButton>
          <ConversationNotification
            value={unread}
            styleProps={{
              position: 'absolute',
              top: '17px',
              right: '15px',
              paddingTop: '0px',
              paddingBottom: '1px',
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ConversationLeftMenuItem;
